<template>
    <section class="breadcrumbs-custom">
        <div class="parallax-container">
          <div class="material-parallax parallax"><img src="/assets/images/custom_cakes_1.png" alt="breadcrumbs" ></div>
          <div class="breadcrumbs-custom-body parallax-content context-dark">
            <div class="container">
                <h2 class="breadcrumbs-custom-title">Custom Cakes</h2>
                <h4>({{ categorySlug }})</h4>
            </div>
          </div>
        </div>
        <div class="breadcrumbs-custom-footer">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
              <li><router-link class="rd-nav-link" to="/custom-cake-category">Custom Cakes Categories</router-link></li>
              <li class="active">{{ categorySlug }}</li>
            </ul>
          </div>
        </div>
    </section>

    <section class="section section-sm section-last bg-default">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-3 col-lg-4 col-xl-4 py-4" v-for="custom_cake in custom_cakes" :key="custom_cake.id">
                    <article class="box-info-modern wow slideInUp" data-wow-delay=".1s">
                      <a class="box-info-modern-figure" data-bs-toggle="modal"
    data-bs-target="#inquiryModal" @click="setCurrentCustomCake(custom_cake)">
                        <!-- <image-component
                          :path="custom_cake.image"
                          disk="images"
                          :skeletonWidth="`340px`"
                          :skeletonHeight="`243px`"
                          :width="`340px`"
                          :height="`243px`"
                        /> -->
                        <img :src="custom_cake.image" :alt="custom_cake.name" width="340" height="243">
                      </a>
                      <a class="box-info-modern-link" href="#">{{ custom_cake.name }}</a>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <CustomCakeInquiryModal :custom-cake="currentCustomCake" :categories="categories" />

</template>

<script setup>
import { onMounted, ref  } from 'vue'
import { useHead } from '@unhead/vue'
import { api } from '@/plugins/axios';
import { useRoute } from 'vue-router'
import { useCartStore } from '@/stores/cart'
import { useCommonStore } from "@/stores/commonStore";
import CustomCakeInquiryModal from '@/components/common/CustomCakeInquiryModal.vue';
import { storeToRefs } from 'pinia';

const cartStore = useCartStore()
const commonStore = useCommonStore();
const custom_cakes = ref([]);
const route = useRoute()
const categorySlug = ref(route.params.category_slug)
const currentCustomCake = ref({});

const { categories } = storeToRefs(commonStore)

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Welcome to CakeGurus.',
    },
  ],
})

function setCurrentCustomCake(custom_cake) {
  currentCustomCake.value = custom_cake;
}

onMounted(async () => {
  commonStore.loaderVisible = true;   
  cartStore.loadCart()
  await getCustomCakes(categorySlug);   
  await commonStore.getCategories();

  const scriptId = 'script-js-script'

  // Check if the script already exists
  const existingScript = document.getElementById(scriptId)

  if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
  }

  // Create and append a fresh script
  const newScript = document.createElement('script')
  newScript.src = '/assets/js/script.js'
  newScript.id = scriptId
  document.body.appendChild(newScript)      

  commonStore.loaderVisible = false;
})

async function getCustomCakes(categorySlug) {
  try {
    const response = await api.get('/get-custom-cakes', {
      params: { category_slug: categorySlug.value }
    })     
    custom_cakes.value = response.data.results
  } catch (error) {
    console.error('Error fetching custom_cakes:', error)
  }
}

</script>

<style scoped>
.material-parallax img { 
  position: relative;
  filter: brightness(0.5);
}
</style>
